import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CmsObject, FAQObject } from 'src/app/model/cmsobject';
import { HttpClient } from '@angular/common/http';
import { UrlMaker } from 'src/app/commons/url-maker';
import { WorkFlowService } from './work-flow.service';

@Injectable({ providedIn: 'root' })
export class CmsService {
    public featureDataSheet: CmsObject[] = [];

    constructor(private http: HttpClient, private workflow: WorkFlowService) {}

    public async getFeatureDataSheets() {
        const lang = this.workflow.getLanguageForCms();

        if (this.featureDataSheet.length == 0) {
            //recupero i datasheet dei fragment
            let f: CmsObject[] = await this.getDataSheet(lang);
            this.featureDataSheet = Object.assign({}, f);
        }
    }

    private async getAllCmsObject(culture: string, pageName: string): Promise<CmsObject[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.cmsServiceUrl)
            .appendSegment('getCmsObj')
            .appendSegment(culture)
            .appendSegment(pageName)
            .toString();

        return this.http.get<CmsObject[]>(url).toPromise();
    }
    async getCmsObj(lang: string, pageName: string) {
        let cmsObj = await this.getAllCmsObject(lang, pageName);
        return cmsObj;
    }

    private async getAllFragmentDataSheetDescription(culture: string): Promise<CmsObject[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.cmsServiceUrl)
            .appendSegment('getDataSheet')
            .appendSegment(culture)
            .toString();

        return this.http.get<CmsObject[]>(url).toPromise();
    }

    public async getAllFragmentGroupDictionary(culture: string): Promise<CmsObject[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.cmsServiceUrl)
            .appendSegment('getFragmentGroupDict')
            .appendSegment(culture)
            .toString();

        return this.http.get<CmsObject[]>(url).toPromise();
    }

    private async getDataSheet(culture: string) {
        let cmsObj: CmsObject[] = await this.getAllFragmentDataSheetDescription(culture);
        return cmsObj;
    }

    async getAllFAQObject(culture: string) {
        let cmsObj = await this.getCmsFAQObject(culture);
        return cmsObj;
    }
    async getCmsFAQObject(culture: string): Promise<FAQObject[]> {
        return this.http.get<FAQObject[]>(environment.settings.cmsServiceUrl + 'getFAQ/' + culture).toPromise();
    }

    async getFragmentDescription(culture: string): Promise<CmsObject[]> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.cmsServiceUrl)
            .appendSegment('getFragmentDescription')
            .appendSegment(culture)
            .toString();

        return this.http.get<CmsObject[]>(url).toPromise();
    }
    async getErrorString(culture: string, pageName: string): Promise<CmsObject> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.cmsServiceUrl)
            .appendSegment('getErrorString')
            .appendSegment(culture)
            .appendSegment(pageName)
            .toString();

        return this.http.get<CmsObject>(url).toPromise();
    }

    public getFeatureDataSheetDetail(fragment: string) {
        if (!fragment) return;
        if (!this.featureDataSheet) return;
        let dataSheetDetail = Object.values(this.featureDataSheet).filter(
            (x) => x.ContentName.toLowerCase() == fragment.toLowerCase() + '_details'
        );

        if (!dataSheetDetail) return 'nessun dettaglio';
        return dataSheetDetail[0] ? dataSheetDetail[0].ContentTranslation : 'nessun dettaglio';
    }
}
